import { createSignal, type VoidComponent } from "solid-js";
import { useTranslation } from "../../../../../state/i18n";
import SettingSection from "../../components/SettingSection";
import { TextInput } from "../../../../../components/inputs/TextInput.tsx";
import { TextButton } from "../../../../../components/button/Button.tsx";
import { isEmpty, noop } from "lodash-es";

// TODO: DEV-8324
const CouponSection: VoidComponent = () => {
  const { t } = useTranslation();

  const [coupon, setCoupon] = createSignal("");

  return (
    <SettingSection
      ariaIdPrefix="coupon"
      title={t(($) => $.SETTINGS_BILLING_COUPON_TITLE)}
      description={t(($) => $.SETTINGS_BILLING_COUPON_DESCRIPTION)}
    >
      <CouponInput coupon={coupon()} onValueChange={setCoupon} onApply={noop} />
    </SettingSection>
  );
};

type CouponInputProps = {
  coupon: string;
  onValueChange: (value: string) => void;
  onApply: () => void;
};

const CouponInput: VoidComponent<CouponInputProps> = (props) => {
  const { t } = useTranslation();

  return (
    <div class="flex w-full gap-1">
      <div class="grow">
        <TextInput
          value={props.coupon}
          onInput={(e) => props.onValueChange(e.currentTarget.value)}
          onBlur={(e) => props.onValueChange(e.currentTarget.value)}
          label={t(($) => $.SETTINGS_BILLING_COUPON_INPUT_LABEL)}
        />
      </div>
      <TextButton
        class="mt-auto"
        text={t(($) => $.SETTINGS_BILLING_COUPON_APPLY_BUTTON)}
        disabled={isEmpty(props.coupon)}
        onClick={props.onApply}
      />
    </div>
  );
};

export default CouponSection;
